var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnitedKingdom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "united-kingdom",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.706,
    height: 24.085,
    viewBox: "0 0 37.706 24.085",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9295",
    "data-name": "Path 9295",
    d: "M0,85.333H37.706v24.085H0Z",
    transform: "translate(0 -85.333)",
    fill: "#f0f0f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9296",
    "data-name": "Path 9296",
    d: "M21.209,85.33H16.5v9.784H0V99.63H16.5v9.784h4.713V99.63h16.5V95.114h-16.5Z",
    transform: "translate(0 -85.33)",
    fill: "#d80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9297",
    "data-name": "Path 9297",
    d: "M317.7,315.358l8.706,5.1v-5.1Zm-6.049,0,14.754,8.637v-2.442l-10.582-6.195Zm10.824,8.637-10.824-6.337v6.337Z",
    transform: "translate(-288.701 -299.911)",
    fill: "#0052b4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9298",
    "data-name": "Path 9298",
    d: "M311.652,315.358l14.754,8.637v-2.442l-10.582-6.195Z",
    transform: "translate(-288.701 -299.911)",
    fill: "#f0f0f0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9299",
    "data-name": "Path 9299",
    d: "M311.652,315.358l14.754,8.637v-2.442l-10.582-6.195Z",
    transform: "translate(-288.701 -299.911)",
    fill: "#d80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9300",
    "data-name": "Path 9300",
    d: "M6.653,315.356,0,319.251v-3.895Zm8.1,1.1v7.539H1.877Z",
    transform: "translate(0 -299.909)",
    fill: "#0052b4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9301",
    "data-name": "Path 9301",
    d: "M10.582,315.358,0,321.552v2.442l14.754-8.637Z",
    transform: "translate(0 -299.911)",
    fill: "#d80027"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9302",
    "data-name": "Path 9302",
    d: "M8.706,93.967,0,88.871v5.1Zm6.049,0L0,85.33v2.442l10.582,6.195ZM3.93,85.33l10.824,6.337V85.33Z",
    transform: "translate(0 -85.33)",
    fill: "#0052b4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9303",
    "data-name": "Path 9303",
    d: "M14.754,93.967,0,85.33v2.442l10.582,6.195Z",
    transform: "translate(0 -85.33)",
    fill: "#f0f0f0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9304",
    "data-name": "Path 9304",
    d: "M14.754,93.967,0,85.33v2.442l10.582,6.195Z",
    transform: "translate(0 -85.33)",
    fill: "#d80027"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9305",
    "data-name": "Path 9305",
    d: "M319.753,93.968l6.653-3.895v3.895Zm-8.1-1.1V85.331h12.877Z",
    transform: "translate(-288.701 -85.331)",
    fill: "#0052b4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9306",
    "data-name": "Path 9306",
    d: "M315.824,93.967l10.582-6.195V85.33l-14.754,8.637Z",
    transform: "translate(-288.701 -85.33)",
    fill: "#d80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdom);
export default __webpack_public_path__ + "static/media/united-kingdom.7b9c427ec75314a5d617e3b8a645f47a.svg";
export { ForwardRef as ReactComponent };